module.exports = __webpack_public_path__ + "static/img/user_value.1a3ce74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user_value.png
// module id = 1D9F
// module chunks = 0